import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import Slider from "react-slick";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import { Carousel as ReactResponsiveCarousel } from "react-responsive-carousel";
import HeroCarouselSlide, { HeroCarouselItemFields } from "./HeroCarouselSlide";
import HeroCarouselIndicator from "./HeroCarouselIndicator";
import HeroCarouselArrow from "./HeroCarouselArrow";
import HeroCarouselScrollSymbol from "./HeroCarouselScrollSymbol";
import getNetworkDownloadSpeed from "../../utils/network.utils";
import { TSitecoreContext } from "../../types/sitecore.types";
import { CheckboxField, StringField } from "../../types/types";
import "react-responsive-carousel/lib/styles/carousel.min.css";

interface HeroCarouselDesktopProps {
  items: HeroCarouselItemFields[];
  showCarouselOverlay: CheckboxField;
  sitecoreContext: TSitecoreContext;
  params: StringField;
  carousalType: StringField;
}

const HeroCarouselDesktop: FunctionComponent<HeroCarouselDesktopProps> = ({
  items,
  params,
  showCarouselOverlay,
  sitecoreContext,
  carousalType,
}) => {
  const interval: number = 10000; // when you change this change also the $interval variable in HeroCarousel > style.scss
  const hasMultipleSlides = items.length > 1;

  const [currentSlide, _setCurrentSlide] = useState(0);

  const isEEActive = sitecoreContext?.pageEditing;
  const isPreview = sitecoreContext?.pageState === "preview";

  const setCurrentSlide = hasMultipleSlides
    ? (index: number) => {
        if (currentSlide != index) {
          _setCurrentSlide(index);
        }
      }
    : () => {};

  const goNext = () => setCurrentSlide(currentSlide + 1);
  const goPrevious = () => setCurrentSlide(currentSlide - 1);

  const [networkSpeed, setNetworkSpeed] = useState(0);

  const videoIsPresent = items.some((item) => item.useVideo.value);
  useEffect(() => {
    if (videoIsPresent) {
      getNetworkDownloadSpeed().then((response) => {
        setNetworkSpeed(parseInt(response));
      });
    }
  }, []);

  const settings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  function CarouselForEE() {
    return (
      <Slider {...settings}>
        {items.map((itemFields, index) => (
          <div className="slide">
            <HeroCarouselSlide
              key={index}
              fields={itemFields}
              params={params}
              carousalType={carousalType}
            />
          </div>
        ))}
      </Slider>
    );
  }

  function Carousel() {
    return (
      <Fragment>
        <div
          className={`carousel-inner-wrapper ${
            carousalType?.value === "Small Carousel" ? "smallCarousal" : ""
          } `}
        >
          <ReactResponsiveCarousel
            infiniteLoop={items.length > 1 ? true : false}
            interval={interval}
            autoPlay={true}
            onChange={setCurrentSlide}
            selectedItem={currentSlide}
            showThumbs={false}
            showArrows={false}
            showIndicators={false}
            showStatus={false}
            stopOnHover={false}
          >
            {items.map((itemFields, index) => {
              const slideInfo = { currentSlide, index, networkSpeed };

              return (
                <HeroCarouselSlide
                  key={index}
                  slideInfo={slideInfo}
                  fields={itemFields}
                  params={params}
                  carousalType={carousalType}
                />
              );
            })}
          </ReactResponsiveCarousel>
          {hasMultipleSlides ? (
            <div className={"controls"}>
              <HeroCarouselArrow direction={"previous"} onClick={goPrevious} />
              <ul className={"controls__dots"}>
                {items.map((_, index) => (
                  <HeroCarouselIndicator
                    baseClassName={"controls__dots__item"}
                    index={index}
                    key={index}
                    isSelected={index == currentSlide}
                  />
                ))}
              </ul>
              <HeroCarouselArrow direction={"next"} onClick={goNext} />
            </div>
          ) : null}
          {showCarouselOverlay?.value && <HeroCarouselScrollSymbol />}
        </div>
        {/* { !isPreview && <CarouselCut /> } */}
      </Fragment>
    );
  }

  const carousel = isEEActive ? CarouselForEE() : Carousel();

  return (
    <section className={"carousel-wrapper hero-carousel"}>{carousel}</section>
  );
};

export default withSitecoreContext()(HeroCarouselDesktop);
